import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { gate } from 'hub-http/gates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SingletonTooltipActionsContext = /*#__PURE__*/createContext(null);
export const useSingletonTooltip = () => {
  return useContext(SingletonTooltipActionsContext);
};
export const SingletonTooltipProvider = ({
  children,
  hasGate
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [target, setTarget] = useState(null);
  const [tooltipContent, setTooltipContent] = useState(null);
  const [tooltipOptions, setTooltipOptions] = useState({});
  const showTooltip = useCallback((newTarget, newContent, options = {}) => {
    setTarget(newTarget);
    setTooltipContent(() => newContent);
    setTooltipOptions(options);
    setIsOpen(true);
  }, []);
  const hideTooltip = useCallback(() => {
    setIsOpen(false);
    setTarget(null);
  }, []);
  const actionsValue = useMemo(() => hasGate(gate('CRM:Datasets:SingletonTooltip')) ? {
    showTooltip,
    hideTooltip
  } : null, [showTooltip, hideTooltip, hasGate]);

  // Determine props for Tooltip
  const ContentProp = typeof tooltipContent === 'function' || typeof tooltipContent === 'object' && tooltipContent !== null && 'render' in tooltipContent ? tooltipContent : undefined;
  const titleProp = ContentProp ? undefined : tooltipContent;
  return /*#__PURE__*/_jsxs(SingletonTooltipActionsContext.Provider, {
    value: actionsValue,
    children: [children, /*#__PURE__*/_jsx(Tooltip, Object.assign({
      open: isOpen && !!target,
      target: target || undefined,
      Content: ContentProp,
      title: titleProp,
      placement: "top"
    }, tooltipOptions, {
      children: /*#__PURE__*/_jsx("span", {
        style: {
          display: 'none'
        }
      })
    }))]
  });
};